import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import UserModel from "../../model/UserModel";

export class PagePersonalStore {
    private rootStore: RootStore | undefined;

    public arUsers = [];
    public arChecked: number[] = [];
    public isCheckedAll = false;
    public search = '';

    public error: string = '';

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init = () => {
        this.arUsers = [];
        this.arChecked = [];
        this.arChecked = [];
        this.isCheckedAll = false;
        this.reload();
        // @ts-ignore
        this.rootStore?.pageRegEmployeeStore.falseRedirect();
        // @ts-ignore
        this.rootStore?.pageRegTradePointStore.falseRedirect();
    }


    @action
    reload() {
        UserModel.getAllChildren(this.setData, this.setError);
    }

    @action
    onActionBlocked = () => {
        if (this.arChecked.length) {
            UserModel.actionChildrenBlocked(this.arChecked, this.init, this.setError);
        } else {
            alert('Выберите записи');
        }
    }

    @action
    onActionActivate = () => {
        if (this.arChecked.length) {
            UserModel.actionChildrenActivate(this.arChecked, this.init, this.setError);
        } else {
            alert('Выберите записи');
        }
    }


    @action
    onActionDeleted = () => {
        if (this.arChecked.length) {
            UserModel.actionChildrenDelete(this.arChecked, this.init, this.setError);
        } else {
            alert('Выберите записи');
        }
    }

    @action
    onCheckboxClick = (id: number) => {
        if (this.arChecked.includes(id)) {
            this.isCheckedAll = false;
            this.arChecked = this.arChecked.filter(f => f !== id);
        } else {
            this.arChecked.push(id);
        }
    }


    @action
    onCheckboxAll = () => {
        this.isCheckedAll = !this.isCheckedAll;
        this.arChecked = [];
        if (this.isCheckedAll) {
            this.arUsers.map((user: any) => {
                this.arChecked.push(user.id);
                return user;
            });
        }
    }


    @action
    setData = (result: any) => {
        result.data.row.map((item: any) => {
            item.updatedAt = new Date(item.updatedAt);
            return item;
        });
        if(result.data.row.length){
            result.data.row=result.data.row.slice(1);
        }
        this.arUsers = result.data.row;
    }


    @action onNewPassword = () => {
        UserModel.getLinkNewPassword(this.redirectPassword, this.setError);
    }

    @action
    redirectPassword = (result: any) => {
        if (result && result.data !== undefined && result.data.url !== undefined) {
            this.rootStore?.mainStore.setRedirectUrl(String(result.data.url));
        }
    }
    @action setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }

    @action onChangeInputTradePoint = (e: any, item: any) => {
        item.TradePoint.value = e;
        UserModel.updateUser(item.id,
            {
                TradePoint: item.TradePoint.value.value
            },
            (result: any) => {
                console.log(result);
            },
            this.setError
        );
    }

    @action onFilterUser = (e: any) => {
        this.search = e.target.value;
    }

}
